import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="bg-dark-200 border-t border-saffron-500 mt-20">
            <div className="max-w-7xl mx-auto px-4 py-12">

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

                    {/* Brand */}
                    <div>
                        <span className="text-saffron-500 font-display text-2xl font-bold">
                            Job<span className="text-white">Freedom</span>
                        </span>
                        <p className="text-gray-400 mt-3 text-sm leading-relaxed">
                            बिहार के युवाओं को सही नौकरी दिलाना हमारा लक्ष्य है।
                            बिल्कुल Free में अपना भविष्य बनाओ।
                        </p>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Quick Links</h4>
                        <div className="flex flex-col gap-2">
                            <Link to="/" className="text-gray-400 hover:text-saffron-500 transition text-sm">Home</Link>
                            <Link to="/about" className="text-gray-400 hover:text-saffron-500 transition text-sm">About Us</Link>
                            <Link to="/contact" className="text-gray-400 hover:text-saffron-500 transition text-sm">Contact</Link>
                            <Link to="/apply" className="text-gray-400 hover:text-saffron-500 transition text-sm">Apply Now</Link>
                        </div>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Contact Us</h4>
                        <div className="flex flex-col gap-2 text-sm text-gray-400">
                            <span>📧 support@jobfreedom.in</span>
                            <span>📞 +91 98765 43210</span>
                            <span>📍 Patna, Bihar</span>
                        </div>
                    </div>

                </div>

                <div className="border-t border-gray-800 mt-10 pt-6 text-center text-gray-500 text-sm">
                    © 2024 JobFreedom. All rights reserved. | Made with ❤️ for Bihar
                </div>

            </div>
        </footer>
    );
}

export default Footer;